import {
    ChangeDetectionStrategy,
    Component,
    input,
    InputSignal,
    InputSignalWithTransform,
    numberAttribute
} from '@angular/core';
import { IconPathPipe } from './icon-path-pipe';
import { IconType } from './icons';

/**
 * The `<app-icon>` component displays custom `SVG` icons.
 *
 * @remarks
 * The size of the icon equals the line-height if not specified.
 */
@Component({
    selector: 'app-icon',
    templateUrl: './icon.html',
    styleUrl: './icon.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'app-icon',
        'role': 'img',
        '[attr.aria-hidden]': 'true',
        '[style.height.px]': 'height()',
        '[style.width.px]': 'width()',
    },
    imports: [
        IconPathPipe,
    ],
})
export class Icon {
    /**
     * The icon type.
     */
    public readonly type: InputSignal<IconType> = input.required<IconType>();

    /**
     * The height of the icon in `px`. Equal to the font-size, if `null`. Defaults to `null`.
     */
    public readonly height: InputSignalWithTransform<number | null, unknown> = input(
        null,
        {
            transform: numberAttribute,
        },
    );

    /**
     * The width of the icon in `px`. Equal to the font-size, if `null`. Defaults to `null`.
     */
    public readonly width: InputSignalWithTransform<number | null, unknown> = input(
        null,
        {
            transform: numberAttribute,
        },
    );
}